module.exports = {"NETWORKS":{"MAIN":"main","MORDEN":"morden","ROPSTEN":"ropsten","RINKEBY":"rinkeby","KOVAN":"kovan","OTHER":"other"},"DAO_ACTIONS":[{"id":0,"enum":"UPGRADE","label":"Upgrade DAO","dataLabel":"New address"},{"id":1,"enum":"ADD_ROOT","label":"Update registrations","dataLabel":"New Merkle root"}]}


//////////////////
// WEBPACK FOOTER
// ./client/constants.json
// module id = 38
// module chunks = 1